import { defaultOperators } from './operators'

const uniquify = {
  pushIfUnique(trackers, columnMap, result, currentItem) {
    return (key) => {
      const column = columnMap[key]
      const foundValue = currentItem[key]
      const transform = (rawValue) => {
        const stringRawValue = String(rawValue, `Uniquify Error: value for "${key}" cannot be converted to a string.`)
        const exists = () => trackers[key].indexOf(stringRawValue) !== -1 && result
        const pushValue = () => {
          trackers[key].push(stringRawValue)
          const option = {
            operator: defaultOperators[column.fieldType] || 'eq',
            text: foundValue ? stringRawValue : 'None',
            value: stringRawValue,
          }

          result[key].push(option)

          return result
        }

        return exists() || pushValue()
      }

      if (Array.isArray(foundValue)) {
        foundValue.forEach((val) => {
          transform(val)
        })
      } else {
        transform(foundValue)
      }

      return result
    }
  },
  valueMap(propertyNames, trackers, columnMap) {
    return (result, currentItem) => {
      propertyNames.forEach(this.pushIfUnique(trackers, columnMap, result, currentItem))

      return result
    }
  },
}

export default uniquify
